import React, { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import LoadingSpinner from 'src/common/components/LoadingSpinner';
import Icon from 'src/common/components/IconDS22';
import Typography from 'src/common/components/Typography';
import UniversalLink from 'src/common/components/UniversalLink';
import styles from './BackButton.module.scss';

export type BackButtonProps = {
  type: 'button' | 'link';
  onClick?: () => void;
  href?: string;
  children?: React.ReactNode;
  classNameModifier?: string;
  disabled?: boolean;
  loading?: boolean;
};

const BackButton: FC<BackButtonProps> = ({
  type,
  onClick,
  href = '',
  children,
  classNameModifier,
  disabled,
  loading,
  ...rest
}) => {
  const content = (
    <>
      <span className={styles.iconWrapper}>
        {loading
          ? <LoadingSpinner />
          : (
            <Icon
              id="arrow-left"
              className={styles.icon}
            />
          )}
      </span>
      {children && (
        <Typography
          className={styles.label}
          type="span"
          size="heading-5"
          weight="semibold"
        >
          {children}
        </Typography>
      )}
    </>
  );

  return (
    <div className={getClassNames(styles, 'root', classNameModifier)}>
      {type === 'link' && (
        <UniversalLink
          className={styles.cta}
          href={href}
          {...rest}
        >
          {content}
        </UniversalLink>
      )}

      {type === 'button' && (
        <button
          onClick={onClick}
          type="button"
          className={getClassNames(styles, 'cta', classNames(classNameModifier, 'button', { disabled }))}
          disabled={disabled}
        >
          {content}
        </button>
      )}
    </div>
  );
};

export default BackButton;
